function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
import { isTransform3dSupported, isVertical } from './utils';
var __vue_script__ = {
  name: 'TabContent',
  props: {
    prefixCls: String,
    tabBarPosition: String,
    animated: Boolean,
    activeIdx: Number
  },
  data: function data() {
    return {
      isSupportedTransform3d: isTransform3dSupported()
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          animated = this.animated;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-content"), true), _defineProperty(_ref, "".concat(prefixCls, "-content-animated"), animated), _defineProperty(_ref, "".concat(prefixCls, "-content-no-animated"), !animated), _ref;
    },
    animateStyle: function animateStyle() {
      var activeIdx = this.activeIdx,
          isSupportedTransform3d = this.isSupportedTransform3d,
          animated = this.animated,
          tabBarPosition = this.tabBarPosition;
      var style = {};

      if (animated) {
        if (activeIdx !== -1) {
          if (isSupportedTransform3d) {
            if (isVertical(tabBarPosition)) {
              style = {
                transform: "translate3d(0, ".concat(-activeIdx * 100, "%, 0)")
              };
            } else {
              style = {
                transform: "translate3d(".concat(-activeIdx * 100, "%, 0, 0)")
              };
            }
          } else {
            style = _defineProperty({}, isVertical(tabBarPosition) ? 'margin-top' : 'margin-left', "".concat(-activeIdx * 100, "%"));
          }
        } else {
          style = {
            display: 'none'
          };
        }
      }

      return style;
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes,
    style: _vm.animateStyle
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "tabContent.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);